<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="cargo" />
        </div>

        <TableVideoaula  :proposta_id="proposta_id" />

      </div>
    </div>
  </div>
</template>

<script>
import sidebar from "@/components/SideBar/SideBar";
import TableVideoaula from "@/components/Tables/Videoaula";
import store from "@/store";

export default {
  data() {
    return {
      proposta_id: this.$route.params.uuid,
      cargo: store.getters.cargo,
      cargoId: store.getters.cargo_id
    };
  },
  components: {
    sidebar: sidebar,
    TableVideoaula: TableVideoaula
  },
};
</script>